//import ExcelColumnData from '@/types/app/excelColumnData';
import ProductExcel from '@/types/app/productsExcel';
import { ProductExcelStateInterface } from './types';

export default {
  getProductsToExcel(state: ProductExcelStateInterface): ProductExcel[] {
    return state.productsToExcel;
  },
  getIsSaving(state: ProductExcelStateInterface): boolean {
    return state.isSavingFile;
  },
  getExcelColumnsData(state: ProductExcelStateInterface): any {
    return state.columns;
  },
  getIsExporting(state: ProductExcelStateInterface): boolean {
    return state.isExportingFile;
  }
};
